module.exports = __webpack_public_path__ + "static/media/pic4@2x.8c5a73d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_146/img/pic4@2x.png
// module id = 1397
// module chunks = 0